/**
 * Module Staff #09 — Loading notes & signatures
 */
const moduleStaffLN = {
  id: 'staff-loading-notes',
  population: 'staff',
  order: 9,
  category: 'Opérations',
  title: 'Loading notes & signatures',
  subtitle: 'Approfondissement signatures, workflows et conformité',
  icon: 'ClipboardList',
  duration: '20 min',
  level: 'Intermédiaire',
  slides: [
    { type: 'cover', eyebrow: 'Module 09 — Staff', title: 'Loading notes', subtitle: 'Signatures, parties prenantes, intégrité', icon: 'ClipboardList', duration: '20 min', audience: 'Opérations terrain', level: 'Intermédiaire' },
    { type: 'intro', title: 'Objectifs', intro: 'Aller au-delà des bons V3 : maîtriser les workflows de signature avancés et leur valeur juridique.', objectives: [
      'Comprendre le concept de "parties prenantes" (sender, carrier, receiver, observer/baobab_operator)',
      'Gérer les loading notes V3 et leur versionning',
      'Auditer les signatures et leur intégrité (SHA-256)',
      'Migrer les anciens "observer" vers "baobab_operator"',
      'Vérifier la conformité OHADA en cas de litige',
    ]},
    { type: 'concept', eyebrow: 'Vocabulaire', icon: 'BookOpen', title: 'Les 4 rôles de signature',
      bullets: [
        '✍️ sender : l\'expéditeur, signe au chargement',
        '🚛 carrier : le chauffeur, signe à chargement + déchargement',
        '📦 receiver : le destinataire, signe à l\'arrivée',
        '👁️ baobab_operator : l\'agent terrain Baobab (remplace l\'ancien "observer")',
      ],
      note: 'Les anciens enregistrements avec party="observer" doivent être migrés.',
    },
    { type: 'steps', title: 'Migrer observer → baobab_operator', steps: [
      { title: 'Identifier les notes avec party="observer"', detail: 'Script de détection en base.' },
      { title: 'Lancer le script de migration', detail: '/app/backend/scripts/migrate_observer_to_operator.py' },
      { title: 'Vérifier l\'audit', detail: 'Chaque migration est journalisée.' },
      { title: 'Régénérer les PDFs concernés', detail: 'Pour mettre à jour la signature affichée.' },
    ]},
    { type: 'comparison', title: 'Bonnes pratiques', do: [
      'Vérifier les 4 rôles avant clôture opération',
      'Conserver l\'historique de toutes les signatures',
      'Auditer le hash SHA-256 si litige',
      'Documenter les exceptions (force majeure)',
    ], dont: [
      'Ne pas modifier une signature après validation',
      'Ne pas accepter une note sans hash valide',
      'Ne pas migrer manuellement (utiliser le script)',
      'Ne pas mélanger observer et baobab_operator',
    ]},
    { type: 'quiz', title: 'Quiz',
      question: 'Une note V2 a party="observer". L\'app affiche "rôle inconnu". Pourquoi ?',
      options: [
        'Bug',
        'Le rôle observer est legacy ; il faut migrer vers baobab_operator (nouveau modèle V3)',
        'Le PDF est corrompu',
        'L\'opération est annulée',
      ],
      answerIndex: 1,
      explanation: 'Le modèle V3 a renommé observer en baobab_operator pour clarté. Une migration de données est nécessaire (script disponible).',
    },
    { type: 'takeaways', title: 'À retenir', items: [
      '4 rôles signature : sender, carrier, receiver, baobab_operator.',
      'observer = legacy, migrer vers baobab_operator.',
      'Hash SHA-256 = preuve intégrité.',
      'Audit obligatoire en cas de litige.',
    ]},
    { type: 'cta', title: 'Module 09 terminé !', actions: [
      { label: 'Loading notes', href: '/admin/loading-notes' },
      { label: 'Catalogue', href: '/docs/admin/training' },
    ]},
  ],
};
export default moduleStaffLN;
